import React, { useEffect, useState } from 'react';
import httpService from '../api/HttpService';
import FindPlayer from './find-player';
import { Player } from '../models/player';
import PlayerWindow from './player-window';
import { usePlayer } from '../context/PlayerContext';
import { Button } from 'react-bootstrap';
import authService from '../api/AuthorizeService';

interface PlayersProps {
}

export const Players: React.FC<PlayersProps> = () => {
    const { player, setPlayer } = usePlayer();

    const [allPlayers, setAllPlayers] = useState<Player[]>();


    useEffect(() => {
        const load = async () => {
            try {
                var s = await httpService.anonGet<Player[]>(`api/players`);
                setAllPlayers(s);
            }
            catch (e) {
                setAllPlayers(undefined);
            }
        };
        if (authService.isAuthenticated() && authService.isSuperAdmin()) {
            load();
        }
    }, []);


    const goToPlayer = (player: Player) => {
        window.location.href += `/${player.id}`;
    }

    return (
        <div>
            <div className='header'>
                <h1>Players</h1>
            </div>
            <FindPlayer onPlayerFound={goToPlayer} text='Search for players to see their matches:'></FindPlayer>
            {player &&
                <>
                    <hr></hr>
                    <h4>Your active profile</h4>
                    <br></br>
                    <PlayerWindow redirectUrl={window.location.href}></PlayerWindow>
                </>
            }
            {allPlayers &&
                <>
                    <div className='header'>
                        <h2>All players</h2>

                    </div>
                    <div>
                        {allPlayers.map(p => <div><a href={`${window.location.href}/${p.id}`}>{p.firstName} {p.lastName}</a></div>)}
                    </div>
                </>}
            <div className='header'>
                <h2>How does it work?</h2>

            </div>
            <div>
                <p>If you have participated in a tournament that has been connected from cuescore to 147board scoreboards,
                    then you are already in the system and you can find yourself with the button above.
                </p>
                {/* TODO: Re-introduce this when ready */}
                {/* <p>Otherwise, you can create a profile with the button below. If you already have a cuescore profile,
                    we recommend to use the option to create your profile with a cuescore id.
                </p>
                <p>
                    <Button href='/create-player'>Create profile</Button>
                </p>
                <p>When you have a profile, simply scan the QR code in the scoreboard when starting a new game.
                    Then your profile will be used when playing matches, and the results will be stored on your profile.
                </p>
                <img src="new-game-qr-codes.png" className="img-fluid mb-1"></img>
                <div><i>Figure 1. New Game screen. Player 1 can be joined with QR code. Player 2 has already been joined by a player.</i></div> */}
            </div>
        </div>
    );
};